<label>
  <div class="mark"></div>
  <input type="radio" />
  <span>
    <ng-content></ng-content>
  </span>
</label>
